<template>
  <div class="flat__floor floor">
    <div class="floor__img">
      <img
        loading="lazy"
        :src="imgSource"
        :width="imgWidth"
        :height="imgHeight"
        :alt="altText"
      />
      <svg class="floor__svg" :viewBox="'0 0 ' + imgWidth + ' ' + imgHeight">
        <polygon
          v-for="flat in allFlats"
          :key="flat.id"
          :points="flat.area_points"
          :class="{
            current: flat.uuid === currentFlatUuid,
          }"
        />
      </svg>
      <a
        href="javascript:void(0)"
        class="stretched-link cursor-zoom"
        @click="openPopup"
      />
    </div>
    <div class="floor__legend">
      <div class="floor__legend-item">
        <div class="floor__legend-item-color" />
        <div class="floor__legend-item-label">Выбранный объект</div>
      </div>
      <div class="floor__legend-item">
        <div class="floor__legend-item-color" />
        <div class="floor__legend-item-label">Свободные лоты</div>
      </div>
    </div>
    <div role="button" class="plan__zoom-button" @click="openPopup">
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 16L1 1M1 1H13.3529M1 1L1 12.4706"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26 26L41 41M41 41H28.6471M41 41L41 29.5294"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlatFloor",
  props: {
    imgSource: {
      type: String,
      required: true,
    },
    imgWidth: {
      type: [Number, String],
      required: true,
    },
    imgHeight: {
      type: [Number, String],
      required: true,
    },
    altText: {
      type: String,
      default: "Расположение на этаже",
    },
    allFlats: {
      type: Array,
      default: () => [],
    },
    currentFlatUuid: {
      type: String,
      required: true,
    },
    currentFlatTitle: {
      type: String,
      default: "",
    },
    areaPoints: {
      type: String,
      default: "",
    },
  },
  methods: {
    openPopup() {
      this.$vfm.show({
        component: "PopupFloor",
        bind: {
          title: "Расположение на&nbsp;этаже",
          img: {
            source: this.imgSource,
            width: this.imgWidth,
            height: this.imgHeight,
          },
          points: this.areaPoints,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.floor {
  position: relative;
  top: -120px;

  img {
    height: auto;
  }

  &__svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    fill: rgba(#ff0020, 0.2);

    polygon {
      opacity: 0.3;

      &.current {
        fill: #ff0020;
        opacity: 0.6;
      }
    }
  }

  &__legend {
    position: absolute;
    bottom: 80px;
    display: flex;
    justify-content: center;
    gap: 20px;
    width: 100%;
  }

  &__legend-item {
    display: flex;
    align-items: center;
    gap: 4px;

    &:first-child {
      .floor__legend-item-color {
        background: #ff808f;
      }
    }

    &:nth-child(2) {
      .floor__legend-item-color {
        background: #ffccd2;
      }
    }
  }

  &__legend-item-color {
    width: 20px;
    height: 20px;
    background: red;
  }
}

.plan__zoom-button {
  position: absolute;
  right: -30px;
  bottom: 30px;
  z-index: 10;
  width: max-content;

  &:hover {
    cursor: pointer;
  }
}

.stretched-link {
  &::after {
    top: 150px;
    bottom: 150px;
  }
}

@media (max-width: 767px) {
  .floor {
    &__legend {
      bottom: -5px;
    }

    > .plan__zoom-button {
      bottom: 40px;
    }
  }
}

@media (max-width: 575px) {
  .floor {
    top: 0;
  }

  .plan__zoom-button {
    position: absolute;
    right: 0;
    bottom: 20px;
    z-index: 10;
    width: max-content;
  }
}
</style>
